export default "__VITE_ASSET__Cl4Z0zGK__"